import EZO_I2C	from "../ezo_i2c.js";

class Module extends EZO_I2C {
  constructor(...args) {
    super(...args);

    this.id = "";
    this.status = "uninitialized";        
  }
  async initialize() {
    try {
      await this.open("/dev/i2c-1", 0x66);      
      this.id = await this.command("i");
      this.calibrationStatus = await this.command("Cal,?");

      this.usbProductName = "ezo_rtd";
      this.usbSerialNumber = "0x66";   
      this.name = "ezortdSensor";

      this.status = "ok";

      /* publicate remote methods to clients */
      jfermi.RM_ezortd_clearCalibration = this.RM_ezortd_clearCalibration.bind(this);
      jfermi.RM_ezortd_calibrateTo = this.RM_ezortd_calibrateTo.bind(this);

    } catch(e) {
      this.status = "failed";
      throw e;
    }
  }  
  async update(devices) {    
    this.value = Math.round(parseFloat(await this.command("R"))*100)/100;
  }
  async clearCalibration() {
    await this.command("Cal,clear");
    this.calibrationStatus = await this.command("Cal,?");          
  }
  async calibrateTo(t) {
    await this.command(`Cal,${t}`);
    this.calibrationStatus = await this.command("Cal,?");        
  }
  async RM_ezortd_clearCalibration(request) {
    try {
      await this.clearCalibration();
      console.log(`${request.client.username}: RTD Sensor calibration data has successfully been deleted`);
    } catch(e) {
      console.error(`${request.client.username}: Clear calibration failed: ${e.message}`);
      throw e;
    }
    return true;
  }
  async RM_ezortd_calibrateTo(request,t) {
    try {
      await this.calibrateTo(t);
      console.log(`${request.client.username}: RTD Sensor has successfully been calibrated to ${t}`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e;
    }
    return true;    
  }  
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,                        
      status: this.status,
      value: this.value,
      calibrationStatus: this.calibrationStatus
    });
  }
}

export default Module;